import {
    Dialog,
    DialogActions,
    DialogContent, DialogTitle,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ButtonExit from "../../button/ButtonExit";
import ButtonAdd from "../../button/ButtonAdd";
import TextFieldValidation from "../customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import {addressInputFields} from "../../../../data/AddressInputFields";

const AddressModal = ({
    open,
    onClose,
    handleSubmit,
    initValue,
    title,
    allCountry,
    loading,
    submitButtonText,
    fullWidth = false,
}) => {
    const [formState, setFormState] = useState(initValue)
    const resolvedSubmitText = submitButtonText ?? (initValue.id ? "Изменить" : "Добавить");

    useEffect(() => {
        setFormState(initValue)
    }, [initValue])

    return (
        <Dialog
            open={open}
            {...(fullWidth ? {fullWidth: true, maxWidth: false} : {})}
            PaperProps={{
                sx: fullWidth
                    ? {
                        width: "calc(100% - 48px)",
                        maxWidth: "100%",
                        maxHeight: "calc(100vh - 64px)",
                        borderRadius: "8px",
                    }
                    : {
                        minWidth: "700px",
                        height: "750px",
                        borderRadius: "8px",
                    },
            }}
        >
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent sx={fullWidth ? {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                rowGap: "12px",
                columnGap: "16px",
                pt: 1,
                pb: 1,
                "& > div": {
                    minHeight: "70px",
                },
            } : {
                display: "flex",
                flexFlow: "column wrap",
                gap: "20px",
                "& > div": {
                    minHeight: "70px",
                },
            }}>
                {Object.entries(formState).map(([key, value]) => key !== "id" &&
                    <TextFieldValidation
                        key={key}
                        select={key === "country"}
                        name={key}
                        value={value ?? ""}
                        label={addressInputFields[key]}
                        inputLabelProps={{shrink: true}}
                        setCurrValues={setFormState}
                        required={false}
                        height={70}
                    >
                        {key === "country" && allCountry?.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>))}
                    </TextFieldValidation>
                )}
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd loading={loading} text={resolvedSubmitText}
                           onClick={() => handleSubmit(formState)}/>
            </DialogActions>
        </Dialog>
    );
}
export default AddressModal